import Icon from '../components/Icon.vue'

Icon.register({
  'street-view': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M367.9 329.8c85.2 15.6 144.1 48.3 144.1 86.2 0 53-114.6 96-256 96s-256-43-256-96c0-38 58.9-70.7 144.1-86.2 4.6 5.3 9.8 10.1 15.9 13.7v22.9c-66.5 9.4-112 28.1-112 49.7 0 30.9 93.1 56 208 56s208-25.1 208-56c0-21.6-45.5-40.3-112-49.7v-22.9c6.1-3.5 11.3-8.4 15.9-13.7zM256 128c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM192 320c-17.7 0-32-14.3-32-32v-96c0-26.5 21.5-48 48-48h11.8c11.1 5 23.3 8 36.2 8s25.1-3 36.2-8h11.8c26.5 0 48 21.5 48 48v96c0 17.7-14.3 32-32 32v96c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/street-view.js
// module id = 1960
// module chunks = 0